import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";
import { formatPresenceDate, getClassPresenceSummary, groupStudentsBySectionAndClass } from "./presenceUtils";

class Presence extends Component {
    state = {
        students: [],
        presences: [],
        months: [],
        monthId: null,
        loading: false,
        expandedClasses: {},
    }

    componentDidMount() {
        const commitmentDate = new Date();
        const month = commitmentDate.getMonth() + 1;
        this.setState({ monthId: month }, () => {
            this.getMonths();
            this.loadData(month);
        });
    }

  getMonths() {
    this.setState({
      months: [
        { id: 9, month: 'Septembre' },
        { id: 10, month: 'Octobre' },
        { id: 11, month: 'Novembre' },
        { id: 12, month: 'Décembre' },
        { id: 1, month: 'Janvier' },
        { id: 2, month: 'Février' },
        { id: 3, month: 'Mars' },
        { id: 4, month: 'Avril' },
        { id: 5, month: 'Mai' },
        { id: 6, month: 'Juin' },
        { id: 7, month: 'Juillet' },
        { id: 8, month: 'Août' },
      ],
    });
  }

    handleInputM = (e) => {
        const monthId = Number(e.target.value);
        this.setState({ monthId }, () => this.loadData(monthId));
    }

    loadData = async (monthId) => {
        this.setState({ loading: true, presences: [] });

        try {
            const studentsPromise =
                !this.state.students || this.state.students.length === 0
                    ? axios.get("students")
                    : Promise.resolve({ data: this.state.students });

            const [studentsResponse, presencesResponse] = await Promise.all([
                studentsPromise,
                axios.get(`presences/${monthId}`)
            ]);

            const students = Array.isArray(studentsResponse.data) ? studentsResponse.data : [];
            const presences = Array.isArray(presencesResponse.data) ? presencesResponse.data : [];

            this.setState({ students, presences, loading: false });

        } catch (error) {
            this.setState({ presences: [], loading: false });
        }
    };

    getPresenceMap = () => {
        const map = new Map();
        (this.state.presences || []).forEach((presence) => {
            const studentId = presence?.student?.id;
            const dateKey = formatPresenceDate(presence?.date);
            if (studentId && dateKey) {
                map.set(`${studentId}|${dateKey}`, presence);
            }
        });
        return map;
    }

    getYearForMonth = (monthId) => {
        const today = new Date();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();
        return currentMonth <= 8 && monthId > currentMonth ? currentYear - 1 : currentYear;
    }

    getMonthDays = (monthId) => {
        if (!monthId) return [];
        const year = this.getYearForMonth(monthId);
        const days = [];
        const date = new Date(year, monthId - 1, 1);
        while (date.getMonth() === monthId - 1) {
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }

        return days;
    }

    getTodayKey = () => formatPresenceDate(new Date());

    getDayLabel = (date) => {
        const weekday = date.getDay();
        const labels = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
        return labels[weekday] || "";
    }

    getStudentLabel = (student) => {
        const user = student?.user || {};
        const parts = [student?.matricule, user?.last_name, user?.family_name, user?.first_name].filter(Boolean);
        return parts.join(" ") || "Élève";
    }

    togglePresence = async (studentId, dateKey, present) => {
        if (!studentId || !dateKey) return;
        const presence = this.getPresenceMap().get(`${studentId}|${dateKey}`);

        if (present && presence?.id) {
            try {
                await axios.delete(`presences/${presence.id}`);
            } catch (error) {
                console.error(error);
            }
        } else if (!present) {
            const now = new Date();
            const hours = `${now.getHours()}`.padStart(2, "0");
            const minutes = `${now.getMinutes()}`.padStart(2, "0");
            const time_start = `${hours}:${minutes}`;
            try {
                await axios.post("presences", { studentId, date: dateKey, time_start });
            } catch (error) {
                console.error(error);
            }
        }

        this.loadData(this.state.monthId);
    }

    toggleClass = (classKey) => {
        this.setState((state) => ({
            expandedClasses: {
                ...state.expandedClasses,
                [classKey]: !state.expandedClasses[classKey],
            },
        }));
    }

    renderStats = () => {
        const sectionGroups = groupStudentsBySectionAndClass(this.state.students);
        const totalClasses = sectionGroups.reduce((total, group) => total + group.classes.length, 0);
        const presenceMap = this.getPresenceMap();
        const todayKey = this.getTodayKey();
        const totalMonth = presenceMap.size;
        const totalToday = Array.from(presenceMap.values()).filter((presence) => formatPresenceDate(presence.date) === todayKey).length;

        return (
            <div className="students-stats" aria-label="Résumé des présences">
                <article className="students-stat">
                    <span className="students-stat__icon"><FeatherIcon icon="users" size={20} /></span>
                    <div>
                        <strong>{this.state.students.length}</strong>
                        <span>Élèves</span>
                    </div>
                </article>
                <article className="students-stat">
                    <span className="students-stat__icon students-stat__icon--success"><FeatherIcon icon="book-open" size={20} /></span>
                    <div>
                        <strong>{totalClasses}</strong>
                        <span>Classes</span>
                    </div>
                </article>
                <article className="students-stat">
                    <span className="students-stat__icon students-stat__icon--purple"><FeatherIcon icon="calendar" size={20} /></span>
                    <div>
                        <strong>{totalMonth}</strong>
                        <span>Présences mois</span>
                    </div>
                </article>
                <article className="students-stat">
                    <span className="students-stat__icon students-stat__icon--warning"><FeatherIcon icon="sun" size={20} /></span>
                    <div>
                        <strong>{totalToday}</strong>
                        <span>Aujourd’hui</span>
                    </div>
                </article>
            </div>
        );
    }

    renderClassTable = (sectionGroup, classGroup, days) => {
        const { sectionClass, students } = classGroup;
        const className = `${sectionClass?.class?.short_entitled_class || ""} ${sectionClass?.title || ""}`.trim();
        const sectionName = sectionGroup.section?.short_entitled_section || sectionGroup.section?.entitled_section || "Section";
        const presenceMap = this.getPresenceMap();
        const todayKey = this.getTodayKey();
        const classKey = `${sectionGroup.section.id}-${sectionClass.id}`;
        const isOpen = Boolean(this.state.expandedClasses[classKey]);
        const summary = getClassPresenceSummary(students, Array.from(presenceMap.values()));

        return (
            <article className="student-class-card" key={sectionClass.id}>
                <div className="student-class-card__header">
                    <button type="button" className="student-section__toggle" onClick={() => this.toggleClass(classKey)} aria-expanded={isOpen}>
                        <span className="student-class-card__icon"><FeatherIcon icon="book-open" size="18" /></span>
                        <div className="student-class-card__title-copy">
                            <h3>{className || "Classe"}  · {sectionName} <span className="learning-performance__badge"> Présences : {summary.total}</span> <span className="learning-performance__badge">Aujourd’hui : {summary.totalToday}</span> </h3>
                            <span>{students.length} {students.length > 1 ? "élèves" : "élève"}</span>
                        </div>
                        <span className="student-class-card__chevron"><FeatherIcon icon="chevron-down" size="18" /></span>
                    </button>

                    <div className="text-end">
                        
                        <ReactToPrint
                            trigger={() => (
                                <button className="btn btn-sm student-class-card__pill" type="button">
                                    <FeatherIcon icon="printer" size="22" />
                                </button>
                            )}
                            content={() => this.componentRef}
                            documentTitle={`Presence des élèves ${(className || "Classe")} ${sectionName}`}
                            pageStyle={`@page { size: A4 landscape; margin: 12mm; }`}
                        />
                    </div>

                </div>
                {
                    isOpen && (
                        <div className={`student-class-card__content${isOpen ? " is-open" : ""}`} ref={(el) => (this.componentRef = el)}>
                            <Headerpdf />
                            <UserIdentity title={`Presence des élèves ${(className || "Classe")} ${sectionName}`}/>
                            <div className="presence-table-wrap">
                                <table className="presence-table">
                                    <thead>
                                        <tr>
                                            <th className="personnel-header">Élève</th>
                                            {days.map((day) => {
                                                const dayKey = formatPresenceDate(day);
                                                return (
                                                    <th key={dayKey} className="presence-day text-center" title={`${this.getDayLabel(day)} ${dayKey}`}>
                                                        {new Date(day).getDate()}
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {students?.sort((a, b) =>
                                                [a.user?.last_name, a.user?.family_name, a.user?.first_name]
                                                .filter(Boolean)
                                                .join(' ')
                                                .localeCompare(
                                                    [b.user?.last_name, b.user?.family_name, b.user?.first_name]
                                                    .filter(Boolean)
                                                    .join(' '),
                                                    undefined,
                                                    { sensitivity: 'base' }
                                                )
                                            )?.map((student) => (
                                            <tr key={student.id}>
                                                <td className="fw-semibold">{this.getStudentLabel(student)}</td>
                                                {days.map((day) => {
                                                    const dayKey = formatPresenceDate(day);
                                                    const present = presenceMap.has(`${student.id}|${dayKey}`);
                                                    const disabled = dayKey > todayKey || day.getDay() === 0;
                                                    return (
                                                        <td key={`${student.id}-${dayKey}`} className={`text-center presence-cell${day.getDay() === 0 ? " presence-sunday" : ""}`}>
                                                            <input
                                                                type="checkbox"
                                                                checked={present}
                                                                disabled={disabled}
                                                                onChange={() => this.togglePresence(student.id, dayKey, present)}
                                                            />
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )
                }
            </article>
        );
    }

    render() {
        const days = this.getMonthDays(this.state.monthId);
        const sectionGroups = groupStudentsBySectionAndClass(this.state.students);
        const monthLabel = this.state.months.find((month) => month.id === this.state.monthId)?.month || "Mois";
        const title = `Présences des élèves - ${monthLabel}`;

        return (
            <div className="ev-page stat-presence-page">
                <header className="students-hero">
                    <div className="students-hero__content">
                        <span className="students-hero__eyebrow">Gestion scolaire</span>
                        <h1>Présences des élèves</h1>
                        <p>Suivez les présences par classe et par jour, avec la liste des élèves intégrée à chaque groupe.</p>
                    </div>
                    <div className="students-hero__actions">
                        <select name="monthId" value={this.state.monthId || ""} className="form-select form-select-sm w-auto" onChange={this.handleInputM}>
                            {this.state.months.map((month) => (
                                <option key={month.id} value={month.id}>{month.month}</option>
                            ))}
                        </select>
                    </div>
                </header>

                <section className="ev-page-section">
                    {this.renderStats()}
                </section>

                <section className="ev-page-section">
                    <div className="ev-page-section__header">
                        <div>
                            <span className="student-profile-section-kicker">Mensuel</span>
                            <h2>{title}</h2>
                        </div>
                    </div>

                    <div>
                        {this.state.loading ? (
                            <div className="text-center text-muted py-4">Chargement...</div>
                        ) : sectionGroups.length === 0 ? (
                            <div className="text-center text-muted py-4">Aucun élève disponible pour ce mois.</div>
                        ) : (
                            <div className="students-sections">
                                {sectionGroups.map((sectionGroup) => (
                                    <article className="student-section is-open" key={sectionGroup.section.id}>
                                        <div className="student-section__toggle" style={{ cursor: "default" }}>
                                            <span className="student-section__badge">{sectionGroup.section.short_entitled_section || "Section"}</span>
                                            <span className="student-section__name">
                                                <strong>{sectionGroup.section.entitled_section}</strong>
                                                <small>{sectionGroup.classes.reduce((total, current) => total + current.students.length, 0)} élèves</small>
                                            </span>
                                        </div>
                                        <div className="student-section__content">
                                            {sectionGroup.classes.map((classGroup) => this.renderClassTable(sectionGroup, classGroup, days))}
                                        </div>
                                    </article>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </div>
        );
    }
}

export default Presence;